<template>
  <footer>
    <main class="footer-component">
      <section class="footer-section-view">
        <nav class="nav">
          <article class="footer-article">
            <h4 class="footer-social-title">También puedes encontrarnos en:</h4>
          <div class="footer-social-links-container">
              <span class="footer-social-icons d-flex justify-content-center align-items-center">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                class="footer-social-icon facebook-icon">
                <i class="pi pi-facebook"></i>
              </a>
            </span>
            <span class="footer-social-icons d-flex justify-content-center align-items-center">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                class="footer-social-icon instagram-icon">
                <i class="pi pi-instagram"></i>
              </a>
            </span>
            <span class="footer-social-icons d-flex justify-content-center align-items-center">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                class="footer-social-icon linkedin-icon">
                <i class="pi pi-linkedin"></i>
              </a>
            </span>
            <span class="footer-social-icons d-flex justify-content-center align-items-center">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                class="footer-social-icon twitter-icon">
                <i class="pi pi-twitter"></i>
              </a>
            </span>
          </div>
          </article>
          <article class="footer-article">
            <span>
              <p>&copy; 2025 <b>Puga & Asociados.</b> <sub>Todos los derechos reservados.</sub></p>
            </span>
            <span>
              <RouterLink :to="{ name: 'privacy' }">Aviso de Privacidad</RouterLink>
            </span>
          </article>

          <article
            class="footer-article d-flex flex-column flex-md-row justify-content-center align-items-center">
            <span>
              <h4 class="footer-social-title">Tu opinión es importante para nosotros;</h4>
              <p>
                Envíanos tus comentarios o sugerencias, para nosotros es importante. De esta manera
                nos ayudas a mejorar nuestros servicios y poder ayudarte a tener un futuro
                m&aacute;s <i>seguro!</i>.
              </p>
              <RouterLink
                class="footer-contact-link"
                :to="{ name: 'contact' }"
                >Escríbenos</RouterLink
              >
            </span>
          </article>
        </nav>
      </section>
    </main>
  </footer>
</template>

<style scoped>
  @import url('/assets/styles/footer.css');
</style>